import React, {useEffect, useState, useContext} from "react";
import {useEstadoApp} from "../context/EstadoAppContext";
import { AuthContext } from "../context/authContext";
import FormularioNuevaONG from "../components/FormularioNuevaONG"
//import FormularioNuevoReferente from "../components/FormularioNuevoReferente";
import TablaOngs from "../components/TablaOngs";
import { optionsPartido, optionsCategoria } from "../datos/options";

export const NuevaONGPage = () => {
    const {estadoAppX, cambiarEstadoApp} = useEstadoApp();
    const { token } = useContext(AuthContext);

    const [ongs, setOngs] = useState([]);
    const [selectedOng, setSelectedOng] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [allOngs, setAllOngs] = useState([]);
    console.log("ALL ONGS --->", allOngs)
    const [filteredOngs, setFilteredOngs] = useState([]);
    const [paginatedOngs, setPaginatedOngs] = useState([]);
    const [filters, setFilters] = useState({
        partido: '',
        categoria: '',
        search: ''
    });
    console.log("FILTER --->", filters)

    useEffect(()=>{
        console.log("estadoAppX", estadoAppX)
        cambiarEstadoApp("inicial")
    }, []) //cuando se monta el componente volver al estado inicial

    // Actualizar la paginación cuando cambien los filtros, la página o items por página
    useEffect(() => {
        if (!Array.isArray(filteredOngs)) return;
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginated = filteredOngs.slice(startIndex, startIndex + itemsPerPage);
        setPaginatedOngs(paginated);
    }, [filteredOngs, currentPage, itemsPerPage]);
    
    // Cargar ONGs solo al montar el componente
    useEffect(() => {
        cargarOngs();
    }, []);

    const cargarOngs = async () => {
        try {
            const respuesta = await fetch('/api/ongs', {
                headers: { 'Authorization': `Bearer ${token}` }
            });//todasONGS
            if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);
            const data = await respuesta.json();
            if (!Array.isArray(data)) throw new Error('Respuesta inválida');
            setAllOngs(data);
            setFilteredOngs(data); // Inicialmente mostramos todos los datos
        } catch (error) {
            console.error('Error al cargar ONGs:', error);
        }
    };

    // Aplicar filtros cuando cambien los filtros o los datos //#FILTER-A
    useEffect(() => {
        let result = [...allOngs];
        
        // Aplicar filtros
        if (filters.partido) {
            result = result.filter(ong => ong.partido_nombre === filters.partido);
        }
        
        if (filters.categoria) {
            result = result.filter(ong => ong.categoria === filters.categoria);
        }
        
        if (filters.search) {
            const searchTerm = filters.search.toLowerCase();
            result = result.filter(ong => 
                (ong.nombre && ong.nombre.toLowerCase().includes(searchTerm)) ||
                (ong.resolucion && ong.resolucion.toString().toLowerCase().includes(searchTerm)) ||
                (ong.codigo && ong.codigo.toString().toLowerCase().includes(searchTerm)) ||
                (ong.ref_1_agrupacion_terminal_politica && 
                 ong.ref_1_agrupacion_terminal_politica.toLowerCase().includes(searchTerm)) ||
                // Los contactos del catalogo tambien se buscan: si el usuario
                // tiene el nombre de alguien y no se acuerda de que ONG es, la
                // lista tiene que traerlo.
                (ong.contactos?.some(c =>
                    (c.nombre || '').toLowerCase().includes(searchTerm) ||
                    (c.telefono || '').toLowerCase().includes(searchTerm) ||
                    (c.email || '').toLowerCase().includes(searchTerm)))
            );
        }
        
        setFilteredOngs(result);
        setCurrentPage(1); // Volver a la primera página al aplicar filtros
        
        // Calcular los registros para la página actual
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginated = result.slice(startIndex, startIndex + itemsPerPage);
        setPaginatedOngs(paginated);
    }, [allOngs, filters]);
    
    // Preparar opciones para los selects
    const partidoOptions = optionsPartido.map(p => ({
        value: p.value,
        label: p.label
    }));
    
    const categoriaOptions = optionsCategoria.map(c => ({
        value: c.value,
        label: c.label
    }));
    
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };
    

    const resetFilters = () => {
        setFilters({
            partido: '',
            categoria: '',
            search: ''
        });
    };

    const handleRowDoubleClick = (ong) => {
        console.log('Doble clic en ONG:', ong);
        setSelectedOng(ong);
    };

    const handleSaveComplete = () => {
        cargarOngs(); // Recargar lista
        setSelectedOng(null); // Limpiar selección
    };

    return (
        <>
            <div className="flex flex-col mb-6 p-4 bg-gray-100  dark:bg-gray-900 rounded-lg shadow-sm">
                <div className="flex flex-col p-4 mb-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
                    <a 
                        href="https://docs.google.com/spreadsheets/d/1kQ9YeNzulk6DFWxpAcTDM7oLfCpHVy722KNznL-g1_g/edit?gid=0#gid=0" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h2a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        Beta: Informar errores/sugerencias
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                            <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                        </svg>
                    </a>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">¡Tu opinión nos ayuda a mejorar!</p>
                </div>
                <div className="dark:bg-gray-900 dark:text-gray-100 p-4 rounded-lg border">

                    {/*<h2 className="text-xl font-bold dark:text-white mb-2">DATOS GENERALES</h2>*/}
                    <div className="w-full">
                        <div className="bg-gray-100 p-6 rounded-md shadow-md w-full">
                            <h2 className="text-xl font-semibold mb-4">Nueva ONG</h2>
                            <FormularioNuevaONG 
                                ongData={selectedOng}
                                onSave={handleSaveComplete}
                                onCancel={() => setSelectedOng(null)}                                
                            />
                        </div>

                        {/* Tabla de ONGs */}
                        <div className="bg-white p-6 rounded-md shadow-md mt-6">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-semibold">Listado de ONGs</h2>
                                <button 
                                    onClick={resetFilters}
                                    className="px-3 py-1 text-sm text-blue-600 hover:text-blue-800"
                                >
                                    Limpiar filtros
                                </button>
                            </div>
                            
                            {/* Filtros */}
                            <div className="space-y-4 mb-6">
                                {/* Filtros de selección */}
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {/* Filtro por partido */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Partido</label>
                                        <select
                                            name="partido"
                                            value={filters.partido}
                                            onChange={handleFilterChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <option value="">Todos los partidos</option>
                                            {partidoOptions.map((partido) => (
                                                <option key={partido.value} value={partido.label}>
                                                    {partido.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    
                                    {/* Filtro por categoría */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Categoría</label>
                                        <select
                                            name="categoria"
                                            value={filters.categoria}
                                            onChange={handleFilterChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <option value="">Todas las categorías</option>
                                            {categoriaOptions.map((categoria) => (
                                                <option key={categoria.value} value={categoria.value}>
                                                    {categoria.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                
                                {/* Búsqueda */}
                                <div className="w-full">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Buscar</label>
                                    <input
                                        type="text"
                                        name="search"
                                        value={filters.search}
                                        onChange={handleFilterChange}
                                        placeholder="Buscar por nombre, resolución, código, referencia o contacto..."
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <TablaOngs 
                                ongs={paginatedOngs}
                                onRowDoubleClick={handleRowDoubleClick}
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalItems={filteredOngs.length}
                                onPageChange={setCurrentPage}
                                onItemsPerPageChange={(newItemsPerPage) => {
                                    setItemsPerPage(newItemsPerPage);
                                    setCurrentPage(1); // Volver a la primera página al cambiar items por página
                                }}
                            />
                        </div>

                        {/* Columna para el formulario de Nuevo Referente - Deshabilitado temporalmente 
                        {false && (
                            <div className="bg-gray-100 p-6 rounded-md shadow-md mt-6">
                                <h2 className="text-xl font-semibold mb-4">Nuevo Referente</h2>
                                <FormularioNuevoReferente />
                            </div>
                        )}
                        */}
                    </div>
                </div>                
            </div>
        </>
    );
}
